import { render, staticRenderFns } from "./PharmaceuticalSaleInfo.vue?vue&type=template&id=1c5a94c6&scoped=true&"
import script from "./PharmaceuticalSaleInfo.vue?vue&type=script&lang=js&"
export * from "./PharmaceuticalSaleInfo.vue?vue&type=script&lang=js&"
import style0 from "./PharmaceuticalSaleInfo.vue?vue&type=style&index=0&id=1c5a94c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5a94c6",
  null
  
)

export default component.exports